import { h, Component } from "preact";
import { Link } from "preact-router/match";
import store from "../store";
import { createForm, formShape } from "rc-form";
import { Text } from "preact-i18n";

class ContactForm extends Component {
  static propTypes = {
    form: formShape
  };
  submit = () => {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.setState({ loading: true });
        let extraData = this.props.extraData ? this.props.extraData : {};
        store
          .sendForm(this.props.type, { ...value, ...extraData })
          .then(res => {
            if (res) this.setState({ loading: false, sent: true });
            else
              this.setState({
                loading: false,
                sendError: (
                  <span>
                    <Text id="contactForm.error" />
                    <a
                      style="color:white;font-weight:bold"
                      href="tel:+371 69 999 999"
                    >
                      69 999 999
                    </a>{" "}
                    <Text id="contactForm.errorLink" />
                  </span>
                )
              });
            document
              .getElementById("page-header")
              .scrollIntoView({ block: "center", behavior: "smooth" });
          });
      } else console.error(error);
    });
  };
  render(props) {
    let { type } = props,
      contentText = this.context.intl.dictionary.contactForm.form.standart
        .contentText,
      submitText = this.context.intl.dictionary.contactForm.form.standart
        .submitText,
      captionText = this.context.intl.dictionary.contactForm.form.standart
        .captionText,
      descriptionText = this.context.intl.dictionary.contactForm.form.standart
        .descriptionText,
      sentText = this.context.intl.dictionary.contactForm.form.standart
        .sentText;
    switch (type) {
      case "support":
        (contentText = this.context.intl.dictionary.contactForm.form.support
          .contentText),
          (submitText = this.context.intl.dictionary.contactForm.form.support
            .submitText),
          (captionText = this.context.intl.dictionary.contactForm.form.support
            .captionText),
          (descriptionText = this.context.intl.dictionary.contactForm.form
            .support.descriptionText),
          (sentText = this.context.intl.dictionary.contactForm.form.support
            .sentText);
        break;
      case "apply":
        (contentText = this.context.intl.dictionary.contactForm.form.apply
          .contentText),
          (captionText = this.context.intl.dictionary.contactForm.form.apply
            .captionText),
          (descriptionText = this.context.intl.dictionary.contactForm.form.apply
            .descriptionText),
          (sentText = this.context.intl.dictionary.contactForm.form.apply
            .sentText);
        break;
    }
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <div id="main" class={props.class} style="position:relative">
        {
          <div
            class={"preloader-small" + (this.state.loading ? " loading" : "")}
          />
        }
        <div class="container">
          {this.state.sent ? (
            <article>
              <h2>
                <Text id="contactForm.title" />
              </h2>
              <p>{sentText}</p>
            </article>
          ) : (
            <article>
              <h2>{captionText}</h2>
              <p>{descriptionText}</p>
              <div class="feedback-form">
                {type == "support" && (
                  <label class="field-icon address">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon">
                      <use xlinkhref="/assets/img/icons.svg#marker"></use>
                    </svg>
                    <input
                      {...getFieldProps("address", {
                        rules: [{ required: true }]
                      })}
                      class={getFieldError("name") ? "input-error" : ""}
                      type="text"
                      placeholder={
                        this.context.intl.dictionary.contactForm.adres
                      }
                      title={this.context.intl.dictionary.contactForm.adres}
                    />
                  </label>
                )}
                <fieldset class="clearfix">
                  <input
                    {...getFieldProps("name", { rules: [{ required: true }] })}
                    class={getFieldError("name") ? "input-error" : ""}
                    type="text"
                    placeholder={this.context.intl.dictionary.contactForm.name}
                    title={this.context.intl.dictionary.contactForm.name}
                  />
                  <input
                    {...getFieldProps("email", {
                      rules: [{ required: true, type: "email" }]
                    })}
                    class={getFieldError("email") ? "input-error" : ""}
                    type="email"
                    placeholder={this.context.intl.dictionary.contactForm.mail}
                    title={this.context.intl.dictionary.contactForm.mail}
                  />
                  <input
                    {...getFieldProps("phone", {
                      rules: [
                        {
                          required: true,
                          type: "string",
                          min: 8,
                          pattern: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g
                        }
                      ]
                    })}
                    class={getFieldError("phone") ? "input-error" : ""}
                    type="tel"
                    placeholder={this.context.intl.dictionary.contactForm.phone}
                    title={this.context.intl.dictionary.contactForm.phone}
                  />
                </fieldset>
                <textarea
                  {...getFieldProps("text", {
                    rules: [
                      {
                        required: true,
                        type: "string",
                        max: 1000
                      }
                    ]
                  })}
                  class={getFieldError("text") ? "input-error" : ""}
                  placeholder={contentText}
                  title={contentText}
                  maxlength="1000"
                ></textarea>
                <div
                  class={
                    getFieldError("agreement")
                      ? "checkbox agreement input-error"
                      : "checkbox agreement"
                  }
                >
                  <input
                    {...getFieldProps("agreement", {
                      rules: [
                        { required: true },
                        {
                          validator: (
                            rule,
                            value,
                            callback,
                            source,
                            options
                          ) => {
                            callback(
                              value
                                ? undefined
                                : this.context.intl.dictionary.contactForm
                                    .policy
                            );
                          }
                        }
                      ],
                      valuePropName: "checked",
                      initialValue: true
                    })}
                    type="checkbox"
                    id="checkbox-agreement"
                  />
                  <label for="checkbox-agreement">
                    <Text id="contactForm.checkbox.text" />
                    <a target="_blank" href={store.prefix + "/privacy"}>
                      <Text id="contactForm.checkbox.link" />
                    </a>
                  </label>
                </div>
                <p class={"error" + (this.state.sendError ? "" : "hidden")}>
                  {this.state.sendError}
                </p>
                <button onClick={this.submit}>{submitText}</button>
              </div>
            </article>
          )}
        </div>
      </div>
    );
  }
}

export default createForm()(ContactForm);



// WEBPACK FOOTER //
// ./components/contact-form.js